import { Box, TextField } from '@mui/material';
import React from 'react';
import { FBInput, FBInputType, FBTextFieldProps } from '..';
import { FBFontStyle } from '../styles/FBFont.styles';
import { FBTextFieldStyles } from '../styles/FBTextField.styles';
import { withFBTextField } from './FBTextField.wrap';

const FBTextField: React.FunctionComponent<FBTextFieldProps> = ({
  onBlur,
  onFocus,
  FBProps: { inputType = 'textfield' } = {},
  placeholder = '',
  multiline,
  defaultValue,
  error,
  rows,
  type,
  inputProps,
  InputProps,
  style,
  dataCy,
  mode,
  className,
  value,
  customHeight,
  helperText,
  isFbEditorField = false,
  ...props
}) => {
  const classes = FBTextFieldStyles({ rows, customHeight, error });
  className = className ?? classes.textfield;
  return (
    <FBInput {...props} {...{ error, defaultValue, isFbEditorField }}
      type={ inputType as unknown as FBInputType} labelProps={FBFontStyle.labelProps}>
      {mode === 'preview' && (
        <Box className={classes.preview}>{defaultValue}</Box>
      )}
      {mode !== 'preview' && (
        <TextField
          data-cy={dataCy ?? props.name}
          label=""
          variant="outlined"
          onBlur={onBlur}
          onFocus={onFocus}
          inputProps={{
            ...inputProps,
            ...((type === 'number') && {
              onWheel: (e) => { e.currentTarget.blur(); },
            }),
          }}

          {...{
            type,
            rows,
            error,
            multiline,
            InputProps,
            style,
            placeholder,
            className,
            value,
            helperText,
          }}

        />
      )}
    </FBInput>
  );
};

export default withFBTextField(FBTextField);
